// extracted by mini-css-extract-plugin
export var columnItem = "_8w-3";
export var columnItemDraggable = "_8w-4";
export var dragHandle = "_8w-0";
export var dragHandleHovered = "_8w-1";
export var dropdown = "_8w-5";
export var dropdownContent = "_8w-7";
export var dropdownInner = "_8w-6";
export var filterDropdownHeader = "_8w-8";
export var icon = "_8w-2";
export var sectionDivider = "_8w-9";